import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = [
    'accordionHeader',
    'accordionContent',
    'accordionWrapper',
    'filterValues',
    'input',
  ];

  static classes = ['selected'];

  static values = {
    searchPath: String,
  };

  connect() {
    this.closeAllAccordions();
    this.updateAllWrapperClasses();
  }

  toggleAccordion = (event) => {
    const content = event.currentTarget.nextElementSibling;
    const willOpen = content.hidden;

    this.closeAllAccordions();

    content.hidden = !willOpen;
    event.currentTarget.setAttribute('aria-expanded', willOpen.toString());
  };

  updateWrapperClasses = (event) => {
    const checkbox = event.target;
    const wrapper = this.accordionWrapperTargets.find((w) =>
      w.contains(checkbox),
    );

    if (wrapper) {
      this.toggleWrapperClasses(wrapper);
    }
  };

  updateAllWrapperClasses = () => {
    this.accordionWrapperTargets.forEach((wrapper) => {
      this.toggleWrapperClasses(wrapper);
    });
  };

  toggleWrapperClasses = (wrapper) => {
    const hasCheckedBoxes =
      wrapper.querySelectorAll('input[type="checkbox"]:checked').length > 0;

    if (hasCheckedBoxes) {
      wrapper.classList.add(...this.selectedClasses);
    } else {
      wrapper.classList.remove(...this.selectedClasses);
    }
  };

  closeAllAccordions = () => {
    this.accordionContentTargets.forEach((content) => {
      const button = content.parentElement.querySelector('button');
      button?.setAttribute('aria-expanded', 'false');
      content.hidden = true;
    });
  };

  apply() {
    const url = new URL(this.searchPathValue);

    this.inputTargets.forEach((checkbox) =>
      url.searchParams.delete(checkbox.name),
    );
    this.inputTargets.forEach((checkbox) => {
      if (checkbox.checked)
        url.searchParams.append(checkbox.name, checkbox.value);
    });

    this.closeModal();

    Turbo.visit(url);
  }

  closeModal() {
    const dialog = this.element.closest('dialog');
    dialog?.close();
  }

  clearFilters(event) {
    const listbox = event.currentTarget.closest('[role="listbox"]');
    if (listbox) {
      listbox.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });

      this.updateAllWrapperClasses();
    }
  }
}
